var _path, _path2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneStandWithPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 77,
    viewBox: "0 0 61 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2284 24.1895L9.67387 58.0557C9.70089 60.8525 10.456 61.9822 12.7133 63.3549L22.7832 68.8988C24.0227 69.5812 25.4752 69.7249 26.7898 69.2952L46.1146 62.9783C46.5726 62.8286 46.5498 62.1747 46.0815 62.0275L29.4572 56.8022C27.5219 56.0307 26.806 55.2589 26.5049 53.0362L24.9381 25.4374L13.2284 24.1895ZM17.9279 36.4227L17.8772 43.7601C17.8704 44.7428 18.6975 45.5537 19.6821 45.5295C20.5819 45.5074 21.2874 44.7909 21.2936 43.8927L21.3444 36.5553C21.3512 35.5726 20.524 34.7617 19.5395 34.7858C18.6396 34.8079 17.9342 35.5244 17.9279 36.4227Z",
    fill: "url(#paint0_linear_2144_1030)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6015 24.1577L11.0469 58.0237C11.074 60.8205 11.829 61.9502 14.0863 63.323L23.9226 69.9609C25.3215 70.905 27.0775 71.1086 28.6077 70.5041L47.6546 62.9803C48.0883 62.809 48.0478 62.1821 47.5939 62.0394L30.8302 56.7703C28.8949 55.9987 28.179 55.227 27.8779 53.0043L26.3111 25.4056L14.6015 24.1577ZM19.3009 36.389L19.2501 43.7264C19.2433 44.7091 20.0704 45.52 21.055 45.4958C21.9549 45.4737 22.6603 44.7572 22.6665 43.859L22.7173 36.5216C22.7241 35.5389 21.8969 34.728 20.9124 34.7521C20.0125 34.7742 19.3071 35.4907 19.3009 36.389Z",
    fill: "url(#paint1_linear_2144_1030)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2144_1030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2961 43.4775C60.2961 43.2986 60.2961 43.06 60.2961 42.8811V40.6744L59.8786 41.569C59.819 41.5094 59.7593 41.3901 59.7593 41.3304L24.0349 4.41326C22.4843 2.80297 21.5301 2.44513 19.1445 3.39938L1.72956 9.30374C1.37172 9.42302 1.07352 9.66158 0.834961 9.90014L0 9.06518V12.2261C0.05964 12.9418 0.2982 13.5978 0.71568 14.1942L34.8894 53.5566C35.9629 55.1669 38.1696 55.6441 39.7799 54.5705L58.7454 46.1613C59.64 45.5649 60.1768 44.551 60.2961 43.4775Z",
    fill: "url(#paint2_linear_2144_1030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6858 43.3586L39.7799 51.7082C38.1696 52.7817 35.9629 52.3046 34.8894 50.6943L0.656041 11.3319C-0.41748 9.72164 -0.238559 7.21675 1.66992 6.44143L19.0848 0.537071C21.4704 -0.41717 22.4247 -0.0593298 23.9753 1.55095L59.6997 38.4085C60.8328 40.0784 60.3557 42.2851 58.6858 43.3586Z",
    fill: "url(#paint3_linear_2144_1030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.12939 14.5528L26.7191 6.14355L54.0342 34.3533L31.0728 44.4921L5.12939 14.5528Z",
    fill: "#0B0B0B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1943 2.38574L13.0611 2.56466L1.72949 6.44126C-0.178989 7.21658 -0.357909 9.72147 0.715611 11.3317L27.6133 42.2849L14.1943 2.38574Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1459 6.28089C14.4073 6.08049 14.4243 5.66375 14.1838 5.35008C13.9433 5.0364 13.5365 4.94457 13.2751 5.14496C13.0137 5.34536 12.9967 5.7621 13.2372 6.07578C13.4777 6.38945 13.8845 6.48129 14.1459 6.28089Z",
    fill: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8342 5.87449C13.7599 5.93148 13.6442 5.90536 13.5758 5.81616C13.5074 5.72695 13.5122 5.60843 13.5866 5.55144C13.6609 5.49444 13.7766 5.52056 13.845 5.60977C13.9134 5.69898 13.9086 5.8175 13.8342 5.87449Z",
    fill: "#305A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6959 41.188C49.4712 42.4405 49.6501 43.8719 48.517 44.5279C47.3838 45.2436 45.8332 44.7664 45.0579 43.514C44.2825 42.2616 44.1036 40.8302 45.2368 40.1742C46.3103 39.4585 47.8609 39.9356 48.6959 41.188Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2784 41.9039C49.0537 43.1563 49.2327 44.5877 48.0995 45.2437C46.9663 45.9594 45.4157 45.4823 44.6404 44.2298C43.8651 42.9774 43.6861 41.546 44.8193 40.89C45.8928 40.1743 47.4435 40.6514 48.2784 41.9039Z",
    fill: "#555555",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3683 41.5689C49.1436 42.8213 49.3225 44.2527 48.1893 44.9088C47.0562 45.6244 45.5055 45.1473 44.7302 43.8949C43.9549 42.6424 43.776 41.2111 44.9091 40.555C45.9827 39.8393 47.5333 40.3165 48.3683 41.5689Z",
    fill: "url(#paint4_linear_2144_1030)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0208 46.2213C57.3529 46.2213 57.6222 45.9275 57.6222 45.5652C57.6222 45.2029 57.3529 44.9092 57.0208 44.9092C56.6887 44.9092 56.4194 45.2029 56.4194 45.5652C56.4194 45.9275 56.6887 46.2213 57.0208 46.2213Z",
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8559 48.4105L51.8559 48.4105L51.8539 48.4114L47.9773 50.0813L47.9773 50.0812L47.973 50.0833C47.6598 50.2399 47.2975 50.0827 47.1944 49.7735L47.1952 49.7732L47.1899 49.7626C47.0333 49.4493 47.1905 49.087 47.4997 48.984L47.4998 48.9843L47.5063 48.9815L51.3829 47.3115L51.383 47.3117L51.3872 47.3095C51.7005 47.1529 52.0628 47.3102 52.1658 47.6193C52.2185 47.7775 52.2058 47.9508 52.1454 48.0984C52.0847 48.2466 51.9796 48.3611 51.8559 48.4105Z",
    fill: "#0C0C0C",
    stroke: "url(#paint5_linear_2144_1030)",
    strokeWidth: 0.166172
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1434 7.35657L17.1434 7.35631L17.1364 7.35918L13.2634 8.96798C12.9648 9.06564 12.6598 8.92115 12.5 8.66379C12.45 8.507 12.4546 8.37461 12.5 8.2726C12.5456 8.16989 12.6391 8.08296 12.7958 8.03074L12.7958 8.0309L12.8012 8.02875L16.5558 6.53885C16.714 6.48669 16.8671 6.48852 16.9977 6.53827C17.1282 6.588 17.2433 6.68821 17.322 6.8455L17.3217 6.84564L17.3258 6.85249C17.4082 6.98988 17.4218 7.091 17.3983 7.16133C17.3756 7.22943 17.3068 7.30213 17.1434 7.35657Z",
    fill: "#0A0A0A",
    stroke: "url(#paint6_linear_2144_1030)",
    strokeWidth: 0.207715
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M47.4517 43.2993L47.4517 43.2993L47.4506 43.2999L46.48 43.7628L46.48 43.7628L46.4779 43.7639C46.3346 43.8425 46.1075 43.7657 46.0305 43.5546L46.0312 43.5544L46.0272 43.5476L45.3954 42.4849C45.3593 42.404 45.3587 42.3006 45.3924 42.2055C45.4262 42.11 45.4931 42.0275 45.5862 41.9866L45.5862 41.9867L45.5874 41.9861L46.558 41.5232L46.558 41.5232L46.5601 41.5221C46.7033 41.4435 46.9305 41.5203 47.0074 41.7314L47.0067 41.7316L47.0107 41.7384L47.6417 42.7997C47.7176 43.0126 47.6386 43.2174 47.4517 43.2993Z",
    stroke: "#7B7C7C",
    strokeWidth: 0.0830861
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2144_1030",
    x1: 26.902,
    y1: 23.8539,
    x2: 28.0342,
    y2: 69.9857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E131A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2144_1030",
    x1: 28.3469,
    y1: 23.8203,
    x2: 29.5124,
    y2: 71.3107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20252B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.706263,
    stopColor: "#495563"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20252B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2144_1030",
    x1: 0.894601,
    y1: 11.3314,
    x2: 37.8714,
    y2: 54.8687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292929"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2144_1030",
    x1: 10.437,
    y1: 3.57868,
    x2: 50.3958,
    y2: 46.2213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#181818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2144_1030",
    x1: 46.5492,
    y1: 40.2207,
    x2: 46.5492,
    y2: 45.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101010"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2144_1030",
    x1: 46.221,
    y1: 50.3962,
    x2: 52.4832,
    y2: 47.8133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.269429
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2144_1030",
    x1: 19.0847,
    y1: 5.66584,
    x2: 11.3315,
    y2: 9.24424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005886,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18171E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2144_1030"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.2961,
    height: 55.167,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneStandWithPhone);
export default __webpack_public_path__ + "static/media/PhoneStandWithPhone.1d150b0bafb04e5d7446f43ccc581810.svg";
export { ForwardRef as ReactComponent };